import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalDocumentTemplateEntry  {
    _originalTypeClassName = "zERP.BO.GeneralJournalDocumentTemplateEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalDocumentTemplateEntry.translate = translateService;
}
this.Id = null;
this.IsDebit = false;
this.CreditValue = null;
this.DebitValue = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsDebit:any;
CreditValue:any;
DebitValue:any;
DebitAmount:any;
Account:any;
CreditAmount:any;
ParentAccount:any;
ActualAccount:any;
AccountInput:any;
Group:any;
static setDebitAmount = ($this, value) => {
var oldValue = $this.DebitAmount;
$this.DebitAmount = value;
if (value != null) {
}
}
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}
static setCreditAmount = ($this, value) => {
var oldValue = $this.CreditAmount;
$this.CreditAmount = value;
if (value != null) {
}
}
static setParentAccount = ($this, value) => {
var oldValue = $this.ParentAccount;
$this.ParentAccount = value;
if (value != null) {
}
}
static setActualAccount = ($this, value) => {
var oldValue = $this.ActualAccount;
$this.ActualAccount = value;
if (value != null) {
}
}
static setAccountInput = ($this, value) => {
var oldValue = $this.AccountInput;
$this.AccountInput = value;
if (value != null) {
}
}
static setGroup = ($this, value) => {
var oldValue = $this.Group;
$this.Group = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}